import React from "react";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import { signInUpWithGoogleOneTap, getUserDetails, clearAuthCookies } from "../../helper/utils";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogin, setUserDetails } from "../../store/actions";
import { get } from "lodash";
import { addSignUpLoginToDataLayer } from "../../helper/datalayer-utils";

function GoogleOneTapSignInUp() {
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const dispatch = useDispatch();
  return (
    <div style={{ visibility: "hidden", height: "0px" }} id="google-one-tap">
      <GoogleLogin
        onSuccess={async (response) => {
          if (response?.credential) {
            sessionStorage.setItem("sso_login_initiated_source", "header_button");
            try {
              const { pushLoginInitiatedEvent } = require("../../helper/datalayer-utils");
              pushLoginInitiatedEvent("header_button");
            } catch (e) {
              console.error("Failed to push login_initiated for google one tap", e);
            }
            await signInUpWithGoogleOneTap(response?.credential);

            const access_token = localStorage.getItem("access_token");
            const refresh_token = localStorage.getItem("refresh_token");

            if (access_token && refresh_token) {
              try {
                const data = await getUserDetails();
                if (data?.status === 401) {
                  // Remove an tokens from localStorage
                  localStorage.removeItem("access_token");
                  localStorage.removeItem("refresh_token");
                  localStorage.removeItem("user");
                  localStorage.removeItem("commentsToken");
                  clearAuthCookies();
                  localStorage.removeItem("last_logged_in_uuid");
                  document.cookie = "qt-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=Lax";
                  sessionStorage.removeItem("subscribe_payment_processing_state");
                  sessionStorage.removeItem("show_support_strip_on_redirect");

                  dispatch(setIsLogin(false));
                  dispatch(setUserDetails(null));

                  googleLogout();

                  let redirectUrl = window.location.origin + "/";
                  const urlParams = new URLSearchParams(window.location.search);
                  const returnUrl = urlParams.get("returnUrl");

                  if (returnUrl) {
                    redirectUrl = returnUrl;
                  } else if (document.referrer && document.referrer.includes(window.location.origin)) {
                    redirectUrl = document.referrer;
                  }

                  setTimeout(() => {
                    window.location.search = "";
                    window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${redirectUrl}`;
                  }, 300);
                } else {
                  addSignUpLoginToDataLayer(window.location.href, data);
                  dispatch(setIsLogin(true));
                  dispatch(setUserDetails(data || {}));
                  localStorage.setItem("user", JSON.stringify(data));
                  try {
                    const { pushLoginCompletedEvent } = require("../../helper/datalayer-utils");
                    pushLoginCompletedEvent("header_button");
                  } catch (e) {
                    console.error("Failed to push login_completed for google one tap", e);
                  }
                }
              } catch (err) {
                console.log(err, "<<<< GOOGLE ONE TAP ERROR >>>>");
              }
            }
          }
        }}
        onError={(error) => {
          console.log(error, "Google one tap error");
        }}
        useOneTap={true}
      />
    </div>
  );
}

export default GoogleOneTapSignInUp;
